import { useEffect, useState } from 'react'
import { RotatingLines } from "react-loader-spinner";
import { Outlet, Navigate, useLocation, useNavigate } from 'react-router-dom'
import Unauthorized from '../pages/Unauthorized';
import { getAxiosResponse, handleError } from "../services/authApiRoutes/APImethods";
import APIUrls from "../services/APIUrls";
import { ConditionalBlock } from '../ConditionalBlock';

function HomePage() {

    const [loading, setLoading] = useState(false);
    const [path, setPath] = useState(null);

    useEffect(() => {
        setLoading(true);
        getAxiosResponse(APIUrls.HOME_PAGE_INFO)
        .then((res) => {
            setLoading(false);
            setPath(res.data.path);
        })
        .catch((error) =>{
            setLoading(false);
            handleError(error);
        })
    })

    return(
      <>
          <ConditionalBlock condition={path !== null}>
                <Navigate to={path}/>
          </ConditionalBlock>
          <div className={loading ? "gb-overlay show" : "gb-overlay hide"}>
            <div className="gb-loader">
              <RotatingLines
                strokeColor="#0096FF"
                strokeWidth="5"
                width="196"
                visible={true}
              />
            </div>
          </div>
      </>
    );



}

export default HomePage;
